import { lazy, Suspense } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { PaginaInicio } from './inicio/PaginaInicio';
import { M } from './mensajes/es-PE';
import { Avisos } from './ui/Avisos';
import { Confirmaciones } from './ui/Confirmaciones';

const PaginaProyecto = lazy(() => import('./proyecto/PaginaProyecto'));
const PaginaDiagnostico = lazy(() => import('../diagnostico/PaginaDiagnostico'));
const PaginaReferencia = lazy(() => import('../diagnostico/PaginaReferencia'));
const PaginaAsistente = lazy(() => import('./asistente/PaginaAsistente'));

const Cargando = () => (
  <div className="pantalla-centrada" role="status">
    {M.app.cargando}
  </div>
);

const router = createBrowserRouter([
  { path: '/', element: <PaginaInicio /> },
  {
    path: '/proyecto/:id',
    element: (
      <Suspense fallback={<Cargando />}>
        <PaginaProyecto />
      </Suspense>
    ),
  },
  {
    path: '/configurar',
    element: (
      <Suspense fallback={<Cargando />}>
        <PaginaAsistente />
      </Suspense>
    ),
  },
  {
    path: '/diagnostico',
    element: (
      <Suspense fallback={<Cargando />}>
        <PaginaDiagnostico />
      </Suspense>
    ),
  },
  {
    path: '/referencia',
    element: (
      <Suspense fallback={<Cargando />}>
        <PaginaReferencia />
      </Suspense>
    ),
  },
  { path: '*', element: <PaginaInicio /> },
]);

export function Aplicacion() {
  return (
    <>
      <RouterProvider router={router} />
      <Avisos />
      <Confirmaciones />
    </>
  );
}
